// extracted by mini-css-extract-plugin
export const wrapper = "Experience-module--wrapper--3q5MN";
export const content = "Experience-module--content--16dF7";